import { render, staticRenderFns } from "./FullPreview.vue?vue&type=template&id=5fd13bcb&scoped=true&"
import script from "./FullPreview.vue?vue&type=script&lang=js&"
export * from "./FullPreview.vue?vue&type=script&lang=js&"
import style0 from "./FullPreview.vue?vue&type=style&index=0&lang=less&"
import style1 from "./FullPreview.vue?vue&type=style&index=1&id=5fd13bcb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd13bcb",
  null
  
)

export default component.exports